
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SubmitGradesToGradeBook"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GroupGrading_SubmitGradesToGradeBookInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"GroupGrading_SubmitGradesToGradeBook"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sgaSubmission"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"SubmitGradesToGradeBookSgaSubmission"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"gradebookEntry"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Grading_GradebookEntry"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"submissionReference"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Grading_SubmissionReference"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SubmitGradesToGradeBookSgaSubmission"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GroupGrading_SgaSubmission"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastGradingAction"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Grading_SgaSubmission_LastGradingAction"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"gradingStepActionMetadata"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Grading_SgaSubmission_StepActionMetadata"},"directives":[]}]}}]}}],"loc":{"start":0,"end":792}};
    doc.loc.source = {"body":"#import \"./GradingGradebookEntryFragment.graphql\"\n#import \"./GradingMetadataFragment.graphql\"\n#import \"./GradingReferenceFragment.graphql\"\n#import \"./GradingLastGradingActionFragment.graphql\"\n\nmutation SubmitGradesToGradeBook($input: GroupGrading_SubmitGradesToGradeBookInput!) {\n  GroupGrading_SubmitGradesToGradeBook(input: $input) {\n    sgaSubmission {\n      ...SubmitGradesToGradeBookSgaSubmission\n    }\n    gradebookEntry {\n      ...Grading_GradebookEntry\n    }\n    submissionReference {\n      ...Grading_SubmissionReference\n    }\n  }\n}\n\nfragment SubmitGradesToGradeBookSgaSubmission on GroupGrading_SgaSubmission {\n  id\n  status\n  lastGradingAction {\n    ...Grading_SgaSubmission_LastGradingAction\n  }\n  gradingStepActionMetadata {\n    ...Grading_SgaSubmission_StepActionMetadata\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./GradingGradebookEntryFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./GradingMetadataFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./GradingReferenceFragment.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("./GradingLastGradingActionFragment.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["SubmitGradesToGradeBook"] = oneQuery(doc, "SubmitGradesToGradeBook");
        
        module.exports["SubmitGradesToGradeBookSgaSubmission"] = oneQuery(doc, "SubmitGradesToGradeBookSgaSubmission");
        
